var exports = {
  "Tp": "xfd349460--62b54d--background",
  "KI": "xfd349460--62b54d--icon_container",
  "rV": "xfd349460--62b54d--click_area",
  "jW": "xfd349460--62b54d--click_area--disabled",
  "q9": "xfd349460--62b54d--click_area--left",
};

module.exports = exports;
